<template lang="pug">
  main
    h1 Take a Course
    aside(class="sidebar courses-available")
      h2 Current STEM Courses Available
      ul
        li
          a(href="https://circuits1.hvullc.com/") <strong>Circuits 1</strong>: Introduction to Electrical Circuits
          span &nbsp; taught by Tim Hanshaw (currently this course is offered at no charge)

    div(class="course-container")
      section(class="main-container just-text")
        div
          h1 For Students: Taking STEM Courses at HVU
          p Students are provided a wide range of educational materials within each course. These materials are organized in “Units”, which are subdivided into “Lessons”.
          h3 <strong>Passive learning materials</strong> within lessons include:
          ul
            li Reference materials (typically text)
            li Videos (summaries of text)
            li Worked examples (sample problems/equations)

          h3 <strong>Active learning materials</strong> are provided in the form of:
          ul
            li <strong>Practice problems</strong> with copious assistance
              ul
                li Hints given for simple problems
                li Help given at each step of a problem
                li Links to related materials provided (additional practice problems and worked problems, videos, and reference materials)

            li <strong>Quizzes</strong>
              ul
                li No hints or help given
                li Links to related examples (worked problems, videos, reference materials and additional practice problems)

          p The goal in creating our classes is to <strong>help students learn the underlying concepts</strong> as they solve problems.
          p The goal of this structure is to <strong>help students quickly identify and rectify misunderstandings and omissions</strong> in their understanding of the course concepts.
</template>

<script>
export default {
  name: "TakeCourse"
};
</script>
